import { noop } from '@socialive/common';
import PropTypes from 'prop-types';
import CreateBroadcast from '../CreateBroadcast';

const NoPastBroadcastsFound = ({ isWebview, loadBroadcasts, reAuth, trackEvent }) => {
  if (isWebview) {
    return (
      <div className="not-found not-found-webview" key="NoPastBroadcasts">
        <img alt="Empty recordings list" src="/icon_conference.png" />
        <h2>No recordings yet</h2>
        <span>Start a live broadcast or record a video</span>
      </div>
    );
  }

  return (
    <div className="not-found" key="NoPastBroadcasts">
      <img src="/no-recordings.png" alt="no-recordings" className="no-recordings-image" />
      <h3>No recordings yet</h3>
      <div className="not-found-text">
        <div className="no-recordings-desc">
          It doesn&apos;t look like anyone has completed a broadcast or <br /> recording yet. Create a broadcast to get
          started.
        </div>
        <CreateBroadcast />
      </div>
    </div>
  );
};

NoPastBroadcastsFound.defaultProps = {
  loadBroadcasts: noop,
};

NoPastBroadcastsFound.propTypes = {
  isWebview: PropTypes.bool.isRequired,
  loadBroadcasts: PropTypes.func,
  reAuth: PropTypes.func.isRequired,
  trackEvent: PropTypes.func.isRequired,
};

export default NoPastBroadcastsFound;
